
<!-- Wrapper Body -->
<div class="wrapper-body dashbaord" *ngIf="show">
	<div class="page-header d-flex align-items-center">
		<h3>Dashboard</h3>
		<!-- <a href="javascript:void(0)" class="ml-auto"><img src="assets/images/icons/notification.svg" width="18"></a> -->
	</div>

	<div class="row">
		<div class="col-12">
			<div class="user-role-card mb-4" *ngIf='userRole!="SUPERADMIN" && show'>
				<div class="row">
					<div class="col-lg-4 col-xl-6">
						<div class="wish h-100 d-flex align-items-center justify-content-center">
							<h3 class="text-purple">
								<span class="text-grey d-block text-small">Welcome!</span>
								{{fullUserName}}
							</h3>
						</div>
					</div>
					<div class="col-md-6 col-lg-4 col-xl-3">
						<div class="card mb-md-0 shadow-none">
							<a href="appointment.html" routerLink="/todays">
								<h6 class="card-heading">Today's Appointments</h6>
								<h2 class="text-green">{{todaysAppts}}</h2>
								<img src="assets/images/icons/date-calendar.svg" width="30">
							</a>
						</div>
					</div>
					<div class="col-md-6 col-lg-4 col-xl-3">
						<div class="card mb-0 shadow-none">
							<a routerLink="/upcoming">
								<h6 class="card-heading">Upcoming Appointments</h6>
								<!-- <h2 class="text-green">{{totalAppts}}</h2> -->
								<h2 class="text-green">{{ongoingAppts}}</h2>
								<img src="assets/images/icons/calendar.svg" width="30">
							</a>
						</div>
					</div>
				</div>
			</div>

			<!-- Notifications -->

			<div class="row" *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR") && show'>

				<!-- Background form not submitted -->
				<div class="col-lg-6">
					<h6 class="mb-3 text-purple">Background form not submitted</h6>
					<div class="card">
						<p *ngIf="backgroundNotSubmit.length<1" class="text-grey text-center py-3 mb-0">No Data</p>
						<div class="table-height">
							<table class="table-sm " *ngIf="backgroundNotSubmit.length>0">
								<thead>
									<tr class="border-bottom text-grey">
										<th class="font-weight-normal">Client Name</th>
										<th class="font-weight-normal">Assessment Date</th>
										<!-- <th class="font-weight-normal">Time</th> -->
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let appt of backgroundNotSubmit" class="border-bottom">
										<td><a
												[routerLink]="['/appt-all-details',appt.appointmentsId]">{{appt.studentFirstName}}
												{{appt.studentLastName}}</a></td>
										<td>{{appt.appointmentDate}}</td>
										<!-- <td>{{appt.appointmentDetails.schedules[0].appointmentTime}}</td> -->
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<!-- Payment Pending -->
				<div class="col-lg-6">
					<h6 class="mb-3 text-purple">Outstanding payments/Balance</h6>
					<div class="card">

						<p *ngIf="paymentList.length<1" class="text-grey text-center py-3 mb-0">No Data</p>
						<div class="table-height">
							<table class="table-sm" *ngIf="paymentList.length>0">
								<thead>
									<tr class="border-bottom text-grey">
										<th class="font-weight-normal">Client Name</th>
										<th class="font-weight-normal">Total</th>
										<th class="font-weight-normal">Pending</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let appt of paymentList" class="border-bottom">
										<td><a
												[routerLink]="['/appt-all-details',appt.appointmentId]">{{appt.clientName}}</a>
										</td>
										<td>{{appt.totalAmount}}</td>
										<td class="text-danger">{{appt.remaing}}</td>
									</tr>
								</tbody>
							</table>
						</div>

					</div>
				</div>
				<!-- Upcoming Follow-Ups -->
				<div class="col-lg-6">
					<h6 class="mb-3 text-purple">Upcoming Follow ups</h6>
					<div class="card">
						<p *ngIf="followUpsNew.length<1" class="text-grey text-center py-3 mb-0">No Data</p>
						<div class="table-height">
							<table class="table-sm" *ngIf="followUpsNew.length>0">
								<thead>
									<tr class="border-bottom text-grey">
										<th class="font-weight-normal">Client Name</th>
										<th class="font-weight-normal">Follow up Date</th>
										<th class="font-weight-normal">Start Time</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let appt of followUpsNew" class="border-bottom">
										<td><a
												[routerLink]="['/appt-all-details',appt.appointmentsId]">{{appt.studentFirstName}}
												{{appt.studentLastName}}</a></td>
										<td>{{appt.appointmentDate}}
										</td>
										<td>{{getDateStart(appt.appointmentTime)}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<!-- Follow-Ups To Be Scheduled -->
				<div class="col-lg-6">
					<h6 class="mb-3 text-purple">Follow-Ups to be scheduled</h6>
					<div class="card">
						<p *ngIf="scheduleFollowUp.length<1" class="text-grey text-center py-3 mb-0">No Data</p>
						<div class="table-height">
							<table class="table-sm" *ngIf="scheduleFollowUp.length>0">
								<thead>
									<tr class="border-bottom text-grey">
										<th class="font-weight-normal">Client Name</th>
										<th class="font-weight-normal">Assessment Date</th>
										<th class="font-weight-normal">Location</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let appt of scheduleFollowUp" class="border-bottom">
										<td><a
												[routerLink]="['/appt-all-details',appt.appointmentsId]">{{appt.studentFirstName}}
												{{appt.studentLastName}}</a></td>
										<td>{{appt.appointmentDate}}</td>
										<td>{{appt.location}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>


			<!-- Notifications -->

			<div class="row" *ngIf='userRole=="SUPERADMIN" && show'>

				<!-- Total Payments Chart -->
				<div class="col-lg-5">
					<div class="card">
						<h6 class="card-heading">Total Payments</h6>
						<canvas baseChart [data]="paymentsPieChartData" [type]="pieChartType"
							[options]="paymentsPieChartOptions" [plugins]="pieChartPlugins"
							(chartClick)="chartClicked($event)">
						</canvas>
					</div>
				</div>

				<div class="col-lg-7">
					<div class="row">
						<!-- Payment Pending -->
						<div class="col-12">
							<h6 class="mb-3 text-purple">Outstanding payments/Balance</h6>
							<div class="card">

								<p *ngIf="paymentList.length<1" class="text-grey text-center py-3 mb-0">No Data</p>
								<table class="table-sm" *ngIf="paymentList.length>0">
									<thead>
										<tr class="border-bottom text-grey">
											<th class="font-weight-normal">Client Name</th>
											<th class="font-weight-normal">Total</th>
											<th class="font-weight-normal">Pending</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let appt of paymentList" class="border-bottom">
											<td><a
												[routerLink]="['/appt-all-details',appt.appointmentId]">{{appt.clientName}}</a></td>
											<td>{{appt.totalAmount}}</td>
											<td class="text-danger">{{appt.remaing}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="col-12">
							<h6 class="mb-4 text-purple">Total appointments at</h6>
						</div>
						<div class="col-md-4">
							<div class="card">
								<a>
									<h6 class="card-heading mb-1">Plano</h6>
									<h2 class="text-green mb-0">{{locationAppt.Plano}}</h2>
								</a>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card">
								<a>
									<h6 class="card-heading mb-1">Houston</h6>
									<h2 class="text-green mb-0">{{locationAppt.Houston}}</h2>
								</a>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card">
								<a>
									<h6 class="card-heading mb-1">Austin</h6>
									<h2 class="text-green mb-0">{{locationAppt.Austin}}</h2>
								</a>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card">
								<a>
									<h6 class="card-heading mb-1">Woodlands</h6>
									<h2 class="text-green mb-0">{{locationAppt.Woodlands}}</h2>
								</a>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card">
								<a>
									<h6 class="card-heading mb-1">Ft. Worth</h6>
									<h2 class="text-green mb-0">{{locationAppt['Ft.Worth']}}</h2>
								</a>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card">
								<a>
									<h6 class="card-heading mb-1">Online</h6>
									<h2 class="text-green mb-0">{{locationAppt.Online}}</h2>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>


			<!-- Total Appointments - Location -->

			<!-- <div class="row" *ngIf='userRole=="SUPERADMIN" && show'>
				<div class="col-12">
					<h6 class="mb-4 text-purple">Total appointments at</h6>
				</div>
				<div class="col-md-3 col-lg-2">
					<div class="card">
						<a>
							<h6 class="card-heading mb-1">Plano</h6>
							<h2 class="text-green mb-0">{{locationAppt.Plano}}</h2>
						</a>
					</div>
				</div>
				<div class="col-md-3 col-lg-2">
					<div class="card">
						<a>
							<h6 class="card-heading mb-1">Houston</h6>
							<h2 class="text-green mb-0">{{locationAppt.Houston}}</h2>
						</a>
					</div>
				</div>
				<div class="col-md-3 col-lg-2">
					<div class="card">
						<a>
							<h6 class="card-heading mb-1">Austin</h6>
							<h2 class="text-green mb-0">{{locationAppt.Austin}}</h2>
						</a>
					</div>
				</div>
				<div class="col-md-3 col-lg-2">
					<div class="card">
						<a>
							<h6 class="card-heading mb-1">Woodlands</h6>
							<h2 class="text-green mb-0">{{locationAppt.Woodlands}}</h2>
						</a>
					</div>
				</div>
				<div class="col-md-3 col-lg-2">
					<div class="card">
						<a>
							<h6 class="card-heading mb-1">Ft. Worth</h6>
							<h2 class="text-green mb-0">{{locationAppt['Ft.Worth']}}</h2>
						</a>
					</div>
				</div>
				<div class="col-md-3 col-lg-2">
					<div class="card">
						<a>
							<h6 class="card-heading mb-1">Online</h6>
							<h2 class="text-green mb-0">{{locationAppt.Online}}</h2>
						</a>
					</div>
				</div>
			</div> -->

			<!-- Appointments Charts -->

			<div class="row" *ngIf='(userRole=="ADMIN" || userRole=="SUPERADMIN") && show'>

				<!-- Monthly Chart -->
				<div class="col-12">
					<div class="card">
						<h6 class="card-heading">Monthly Appointments</h6>
						<canvas height="280" baseChart [data]="barChartData" [options]="barChartOptions"
							[plugins]="barChartPlugins" [type]="barChartType"></canvas>
					</div>
				</div>
			</div>

			<div class="row" *ngIf='userRole=="ADMIN" && show'>

				<!-- Anually Appointments Chart -->
				<div class="col-md-6 col-lg-5">
					<div class="card">
						<h6 class="card-heading">Annual Appointments</h6>
						<canvas baseChart [data]="apptPieChartData" [type]="pieChartType"
							[options]="apptPieChartOptions" [plugins]="pieChartPlugins"
							(chartClick)="chartClicked($event)">
						</canvas>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
	<!-- <p style="color: white">Please Wait... </p> -->
</ngx-spinner>